import React, { useState } from 'react';
import CloneTestCycleModal from './CloneTestCycleModal';
import { deletionIssues } from './static-data';
import ConfirmationModal from '../../elements/ConfirmationModal';
import { SecondaryTabsTestCycles } from '../../elements/SecondaryTabs';
import { deleteTestCycle } from '../../../modules/testcycles';

const TestCycleTableActions = ({
  handleOpenTestCycleModal,
  selectedItems,
  isSelectedItems,
  selectedRows,
  addNotification,
  refreshData,
}) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showCloneModal, setShowCloneModal] = useState(false);

  const handleDeleteTestcycle = async () => {
    try {
      await deleteTestCycle({
        testcycles: selectedItems,
      });
      refreshData();
      addNotification('success', 'Test cycle(s) deleted successfully!');
      setShowConfirmationModal(false);
    } catch (error) {
      const errorMessage =
        error?.message ||
        'Failed to delete test cycle. Please try again later.';
      addNotification('danger', errorMessage);
    }
  };

  const handleCloneTestcycle = async () => {
    setShowCloneModal(true);
  };

  const handleCloseModal = () => {
    setShowConfirmationModal(false);
  };

  return (
    <>
      <SecondaryTabsTestCycles
        handleOpenTestCycleModal={handleOpenTestCycleModal}
        isSelectedItems={isSelectedItems}
        handleCloneTestcycle={handleCloneTestcycle}
        setShowConfirmationModal={setShowConfirmationModal}
        fetchTestCycles={refreshData}
        refreshData={refreshData}
      />
      <ConfirmationModal
        show={showConfirmationModal}
        handleClose={handleCloseModal}
        handleConfirm={handleDeleteTestcycle}
        title="Remove Test Cycle"
        body={
          <>
            <span>
              Removing the test cycle(s) will permanently remove the following:
            </span>
            <span>
              {deletionIssues.map((issue, index) => (
                <li key={index}>{issue}</li>
              ))}
            </span>
            <span>This action cannot be undone.</span>{' '}
            <strong>Are you sure you want to delete the test cycle(s)?</strong>
          </>}
        buttonLabel="Delete"
      />
      <CloneTestCycleModal
        show={showCloneModal}
        handleClose={() => setShowCloneModal(false)}
        entityToClone={selectedRows[0]}
        fetchTestCycles={refreshData}
      />
    </>
  );
};

export default TestCycleTableActions;
